import React, { useState, useEffect } from 'react';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Pagination from '@mui/material/Pagination';
import Grid from '@mui/material/Grid';

import { BrowserView, MobileView, isDesktop, isMobile } from 'react-device-detect';

import { LocalizationContext } from '../App';


import QrCodeIcon from '@mui/icons-material/QrCode';
import LanguageIcon from '@mui/icons-material/Language';
import MenuIcon from '@mui/icons-material/Menu';
import SettingsIcon from '@mui/icons-material/Settings';
import WbSunnyIcon from '@mui/icons-material/WbSunny';
import NightlightIcon from '@mui/icons-material/Nightlight';
import RoomIcon from '@mui/icons-material/Room';
import TagIcon from '@mui/icons-material/Tag';
import { alpha, styled } from '@mui/material/styles';

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';

const HelpComponentBasicHelp = (props) => {

    const [ currentPage, setCurrentPage ] = useState(1);
    
    const handlePaginationChange = (event, value) => {
        setCurrentPage(value);        
    };

    const bg = ('light' == 'light') ? "#ffffff66" : "#12121266";

    return (
        <LocalizationContext.Consumer>

        { ({strings}) => (

            <React.Fragment>

                <Box sx={{ height : '100%', width : '100%' }}>                        
                    
                    <Box sx={{ 
                        height : '100%',
                        display : 'flex', 
                        flexFlow : 'column' }}>
                        
                        <Stack 
                            direction="column" 
                            sx={{ overflow : 'auto', flex : "1 1 auto"}}>


                            <Typography className="mb-4" variant="overline" gutterBottom>
                                {strings.getString("help.basic.title")}
                            </Typography>


                            {currentPage == 1 &&
                                <>
                                    <Typography variant="subtitle1" gutterBottom>
                                        {strings.getString("help.basic.head0a")}
                                    </Typography>
                                    <p/>
                                    <Stack direction="row">
                                        <Typography variant="button">
                                            {strings.getString("controls.buttons.activity.local")}
                                        </Typography>
                                        /
                                        <RoomIcon />
                                    </Stack>
                                    <p/>
                                    <Typography variant="body2" gutterBottom>
                                        {strings.getString("help.basic.para0a")}
                                    </Typography>
                                </>
                            }

                            {currentPage == 2 &&
                                <>
                                    <Typography variant="subtitle1" gutterBottom>
                                        {strings.getString("help.basic.head0b")}
                                    </Typography>
                                    <p/>
                                    
                                    <Paper className="loupe-gradient padding">
                                        <Grid container>
                                            <Grid item xs="auto">
                                                <TagIcon className="text-white"/>
                                            </Grid>
                                            <Grid item xs={1} />
                                            <Grid item xs>
                                                <Typography className="text-start text-white mb-4" variant="body2" gutterBottom component="div">
                                                    { isMobile == true ? 
                                                        (strings.getString("texts.entercode_mobile")) : (strings.getString("texts.entercode"))
                                                    }
                                                </Typography>                                    
                                            </Grid>
                                        </Grid>
                                        
                                        <div style={{background : bg, padding : 10, borderRadius : 5}} className="mb-4 step-here">
                                            <div className="e-float-input">
                                                <input type="text" disabled/>
                                                <span className="e-float-line"/>
                                                <label className="e-float-text text-white">CODE</label>
                                            </div>
                                        </div>
                                        
                                    </Paper>

                                    <p/>
                                    <Typography variant="body2" gutterBottom>
                                        {strings.getString("help.basic.para0b")}
                                    </Typography>
                                </>
                            }


                            {currentPage == 3 &&
                                <>
                                    <Typography className="mb-3" variant="subtitle1" gutterBottom>
                                        {strings.getString("help.basic.head1")}
                                    </Typography>

                                    <LanguageIcon className="mb-3"/>
                                    <Typography className="mb-5" variant="body2" gutterBottom>
                                        {strings.getString("help.basic.para1")}
                                    </Typography>
                                </>
                            }

                            {currentPage == 4 &&
                                <>
                                    <Typography className="mb-3" variant="subtitle1" gutterBottom>
                                        {strings.getString("help.basic.head2")}
                                    </Typography>
                                                                                
                                    <MenuIcon className="mb-3"/>
                                    <Typography className="mb-5" variant="body2" gutterBottom>
                                        {strings.getString("help.basic.para2")}
                                    </Typography>

                                    <Stack direction="row" className="mb-3">
                                        <WbSunnyIcon />
                                        /
                                        <NightlightIcon/>
                                    </Stack>
                                    <Typography className="mb-5" variant="body2" gutterBottom>
                                        {strings.getString("help.basic.para3")}
                                    </Typography>
                                </>
                            }   


                   
                        </Stack>

                        <Pagination  
                            sx={{ flex : "0 1 auto", marginTop : "auto" }}                           
                            variant="outlined" 
                            color="primary" 
                            className="container" 
                            count={4} 
                            page={currentPage} 
                            onChange={handlePaginationChange} />

                    </Box>
                    

                </Box>

            </React.Fragment>
        
        )}

        </LocalizationContext.Consumer>
    )

}
export default HelpComponentBasicHelp;